<template>
    <div class="loginContainer">
        <div style="display: flex; justify-content: center; align-items: center; height: 100%;">
            <div style="width: 430px; min-height: 240px; background-color: #fff;">
                <img src="/static/img/login-image.png" alt="logo">
                <el-form
                    novalidate
                    class="vue-container"
                    style="padding: 20px;"
                >
                    <el-form-item :label="$store.getters.getText('form_reset_password_placeholder_password')">
                        <el-input type="password" v-model="password1" required auto-complete="off"></el-input>
                    </el-form-item>
                    <el-form-item :label="$store.getters.getText('form_reset_password_placeholder_confirmation')">
                        <el-input type="password" v-model="password2" required auto-complete="off"></el-input>
                    </el-form-item>
                    <div class="reset">
                        <el-button v-loading="sendingRequest" class="greenButton" @click="resetPassword()">{{$store.getters.getText('login_password_reset_button')}}</el-button>
                    </div>
                </el-form>
            </div>
        </div>
    </div>
</template>

<script>
import {mapGetters} from 'vuex';
export default {
    data () {
        return {
            password1: '',
            password2: '',
            error: '',
            sendingRequest: false
        };
    },
    computed: {
        ...mapGetters([
            'getText',
            'locationQueryParams'
        ])
    },
    methods: {

        resetPassword() {
            this.$store.dispatch(
                'changeUserPassword',
                {
                    password1: this.password1,
                    password2: this.password2,
                    password_change_token: this.locationQueryParams.token,
                    email: this.locationQueryParams.email,
                }
            ).then(() => {
                this.$notify.success({
                    message: this.getText('form_reset_password_success'),
                });
                this.$store.dispatch('loginUser', {
                    email: this.locationQueryParams.email,
                    password: this.password1,
                }).then(() => {
                    this.$router.push({name: 'home'});
                }).catch((error) => {
                    this.$router.push({name: 'login'});
                });
            }).catch((err) => {
                console.error(err);
                this.$notify.error({
                    message: this.getText('form_reset_password_fail')
                });
            });

        },
    }
};
</script>

<style lang=less>
@import '../../less/variables.less';
.loginContainer{
    width:100%;
    height:100%;
    position: fixed;
    top:0px;
    left:0px;
    background: #23262B;
    color: #555;
    font-family: 'Open Sans', sans-serif;
    font-size: 12px;
    line-height: 1.42857143;
    font-weight: 300;
    .el-form-item {
        input:focus {
            border-color: @color-1;
        }
    }

    .login, .reset {
        text-align: center !important;
        margin-top: 20px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/page/resetPassword.vue